import i18next, {} from 'i18next';
import ICU from 'i18next-icu';
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, resources } from './locales.js';
/**
 * Create an isolated i18next instance for web (Admin_Portal, Operator_Console) and
 * mobile, preloaded with en/si/ta resources and ICU message formatting.
 * Resources are bundled, so initialisation completes synchronously.
 */
export function createI18n(options = {}) {
    const instance = i18next.createInstance();
    instance.use(new ICU());
    for (const plugin of options.plugins ?? [])
        instance.use(plugin);
    void instance.init({
        lng: options.locale ?? DEFAULT_LOCALE,
        fallbackLng: DEFAULT_LOCALE,
        supportedLngs: [...SUPPORTED_LOCALES],
        resources: {
            en: { translation: resources.en },
            si: { translation: resources.si },
            ta: { translation: resources.ta },
        },
        initAsync: false,
        returnNull: false,
        interpolation: { escapeValue: false }, // React escapes output
        ...options.init,
    });
    return instance;
}
/** Switch language at runtime without reload or re-login (Req 22.2). */
export async function setLocale(instance, locale) {
    await instance.changeLanguage(locale);
}
//# sourceMappingURL=i18next.js.map